// Exporta a lista de pessoas no padrão de importação da Smart Talks (CSV):
//   name,phone,email,casado,filhos
//
// - phone: somente dígitos, com o código do país (ex.: 5511999999999)
// - casado / filhos: não existem no cadastro, ficam em branco

const HEADER = ['name', 'phone', 'email', 'casado', 'filhos'];

// Normaliza o telefone para o formato 55 + DDD + número (somente dígitos).
export const normalizePhone = (telefone) => {
  const digits = String(telefone || '').replace(/\D/g, '');
  if (!digits) return '';
  // Já veio com o código do país (55 + DDD + número → 12 ou 13 dígitos)
  if (digits.startsWith('55') && (digits.length === 12 || digits.length === 13)) return digits;
  // DDD + número (10 ou 11 dígitos) → prefixa o 55
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return digits;
};

// Escapa o valor para CSV (aspas quando houver vírgula, aspas ou quebra de linha).
const escapeCsv = (value) => {
  const str = String(value == null ? '' : value).trim();
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const buildSmartTalksCsv = (pessoas) => {
  const rows = pessoas.map((pessoa) => [
    pessoa.nome,
    normalizePhone(pessoa.telefone),
    pessoa.email,
    '', // casado
    '', // filhos
  ]);
  return [HEADER, ...rows].map((row) => row.map(escapeCsv).join(',')).join('\r\n');
};

// Gera o CSV e dispara o download no navegador.
export const downloadSmartTalksCsv = (pessoas, prefix = 'smart-talks') => {
  const csv = buildSmartTalksCsv(pessoas);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${prefix}-${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
